import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { TaskService } from '../../core/services/task.service';
import { Task } from '../../core/models/task.model';
import { TaskFormBaseComponent } from '../task-form-base.component';

@Component({
  selector: 'app-task-update',
  templateUrl: './task-update.component.html',
  styleUrls: ['./task-update.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
})
export class TaskUpdateComponent extends TaskFormBaseComponent implements OnInit {
  taskId!: number;

  constructor(
    protected override fb: FormBuilder,
    private taskService: TaskService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(fb);
  }

  ngOnInit(): void {
    this.taskId = +this.route.snapshot.paramMap.get('id')!;
    this.taskService.getTaskById(this.taskId).subscribe({
      next: (task: Task) => {
        this.taskForm.patchValue(task);
      },
      error: error => {
        console.error('Error al cargar la tarea:', error.message);
        this.errorMessage = error.error.message || 'Ocurrió un error al cargar la tarea';
      },
    });
  }

  onSubmit(): void {
    if (this.taskForm.valid) {
      const updatedTask: Task = { ...this.taskForm.value, id: this.taskId };
      this.taskService.updateTask(updatedTask).subscribe({
        next: () => {
          this.router.navigate(['/tasks']);
        },
        error: error => {
          console.error('Error al actualizar la tarea:', error.message);
          this.errorMessage = error.error || 'Ocurrió un error al actualizar la tarea';
        },
        complete: () => {
          console.log('Solicitud de actualización de tarea completada');
        },
      });
    } else {
      this.markAllFieldsAsTouched();
    }
  }
}
